import { combineReducers } from "@reduxjs/toolkit";
import {getCrewTeamDataSlice}  from "./crewBaseSlice"

export const crewBaseRoootReducer = combineReducers({
    getCrewData: getCrewTeamDataSlice.reducer
  });